// Guest Memory inside the folio modal — returning badge, memo, AI hint for this booking.
import React, { useCallback, useEffect, useState } from 'react';
import { Brain, Loader2 } from 'lucide-react';
import { apiCall } from './_shared';
import { GuestRow } from './GuestMemoryCard';
import PastStays from './PastStays';
import { TierPanel } from './TierBadge';

const FolioMemory = ({ bookingId, userRole }) => {
  const [g, setG] = useState(null);
  const [err, setErr] = useState('');
  const load = useCallback(() => {
    apiCall(`/api/admin/reception/guest-memory/booking/${bookingId}`).then(setG).catch((e) => setErr(e.message));
  }, [bookingId]);
  useEffect(() => { load(); }, [load]);

  if (err) return null;
  if (!g) return <p className="text-xs text-slate-400 flex items-center gap-1" data-testid="folio-memory-loading"><Loader2 className="w-3 h-3 animate-spin" /> Loading guest memory…</p>;
  const canEdit = ['super_admin', 'admin', 'manager', 'reception'].includes(userRole);
  return (
    <div data-testid="folio-memory">
      <p className="text-[10px] uppercase tracking-widest text-emerald-700 font-bold mb-1 flex items-center gap-1"><Brain className="w-3 h-3" /> Guest memory</p>
      {g.loyalty && <div className="mb-2"><TierPanel bookingId={bookingId} loyalty={g.loyalty} canEdit={canEdit} onChanged={load} testId="folio-tier" /></div>}
      <ul><GuestRow g={g} date={g.check_in} canEdit={canEdit} onSaved={load} hintBody={{ booking_id: bookingId }} /></ul>
      {g.returning && <div className="mt-2"><PastStays history={(g.history || []).map((h) => ({ beds24_id: h.booking_id, check_in: h.check_in, check_out: h.check_out, nights: h.nights, room_name: h.room_name, total_price: h.total, source: h.source }))} stays={g.stays} totalNights={g.total_nights} totalSpend={g.total_spend} favouriteRoom={g.favourite_room} testId="folio-past-stays" /></div>}
    </div>
  );
};

export default FolioMemory;
